import { render } from "./BaseButton.vue?vue&type=template&id=a6c58ca6&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=a6c58ca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6c58ca6"]])

export default __exports__